import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { router } from './router';
import { theme } from './theme/theme';
import { applyChartDefaults } from './theme/chartDefaults';
import { setupResponseInterceptor, setupRequestInterceptor } from './api/interceptors';
import './styles/main.scss';
import moment from 'moment';
import 'moment/dist/locale/fr';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

moment.locale('fr');
dayjs.locale('fr');

// Après une mise en ligne, un onglet resté ouvert demande les fichiers de l'ancienne version, qui n'existent plus
// (« Failed to fetch dynamically imported module ») : on recharge la page pour prendre la nouvelle version.
// Une fois par minute au plus, pour ne pas boucler si un fichier manque vraiment.
const STALE_RELOAD_KEY = 'runnrz-admin:stale-reload-at';
window.addEventListener('vite:preloadError', (event) => {
  let lastReload = 0;
  try {
    lastReload = Number(sessionStorage.getItem(STALE_RELOAD_KEY)) || 0;
  } catch {
    // stockage indisponible (navigation privée) : on recharge quand même
  }
  if (Date.now() - lastReload < 60_000) return;
  try {
    sessionStorage.setItem(STALE_RELOAD_KEY, String(Date.now()));
  } catch {
    // idem
  }
  event.preventDefault();
  window.location.reload();
});

// Configurer les intercepteurs Axios pour gérer les erreurs 401
setupRequestInterceptor();
setupResponseInterceptor();
applyChartDefaults();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);
